angular
.module("app")
.controller("dettagliCalcoloCtrl", function(){

});